import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import WrapArrow from "../primitives/WrapArrow";

const SPONSOR = "sponsor";
const BIG_SPONSOR = "bigSponsor";
const PARTNER = "collaborator";
const HOST = "host";

const Sponsors = () => {
  const { allSanitySponsor } = useStaticQuery(
    graphql`
      query {
        allSanitySponsor {
          nodes {
            title
            link
            type
            image {
              asset {
                url
              }
            }
            imageWithColor {
              asset {
                url
              }
            }
          }
        }
      }
    `
  );

  const sponsors = [];
  const bigSponsors = [];
  const partners = [];
  const hosts = [];

  const { nodes } = allSanitySponsor;

  nodes.forEach(node => {
    if (node.type === SPONSOR) sponsors.push(node);
    else if (node.type === BIG_SPONSOR) bigSponsors.push(node);
    else if (node.type === PARTNER) partners.push(node);
    else if (node.type === HOST) hosts.push(node);
  });

  if (sponsors.length < 1 && partners.length < 1 && hosts.length < 1)
    return null;

  return (
    <div
      className="
        flex flex-wrap
        pt-16
        pb-8
      "
    >
      {hosts.length > 0 && (
        <>
          <div className="w-full py-2 flex flex-col items-center border-solid border-black border-t xl:border-t-6">
            <h2 className="uppercase pt-4">
              <WrapArrow direction="down" />
              Makes the magic happen
              <WrapArrow direction="down" />
            </h2>
            <div className="flex justify-center flex-wrap w-full space-x-5">
              {hosts.map(({ title, link, imageWithColor, image }, i) => (
                <div className="py-6 w-1/2 md:w-1/3" key={`sponsor_link_${i}`}>
                  <a
                    href={link}
                    target="_blank"
                    className="netlife-sans font-bold"
                    rel="noopener noreferrer"
                  >
                    <img
                      className="object-cover w-full"
                      src={
                        imageWithColor?.asset?.url || image?.asset?.url || ""
                      }
                      alt={`${title} logo`}
                    />
                  </a>
                </div>
              ))}
            </div>
          </div>
        </>
      )}

      {bigSponsors.length > 0 && (
        <>
          <div className="w-full py-2 uppercase flex flex-col items-center border-solid border-black border-t xl:border-t-6">
            <h2 className="uppercase pt-4">Unicorn sponsors</h2>
            <div className="flex flex-wrap items-center justify-center w-full pt-4">
              {bigSponsors.map(({ title, link, imageWithColor, image }, i) => (
                <a
                  key={`sponsor_link_${i}`}
                  href={link}
                  target="_blank"
                  className="pr-10 py-2 w-1/2 lg:w-1/4 lg:pr-8 flex items-center justify-center"
                  rel="noopener noreferrer"
                >
                  <img
                    className="object-cover w-full brightness-0"
                    src={imageWithColor?.asset?.url || image?.asset?.url || ""}
                    alt={`${title} logo`}
                  />
                </a>
              ))}
            </div>
          </div>
        </>
      )}

      {sponsors.length > 0 && (
        <>
          <div className="w-full py-2 uppercase flex flex-col items-center border-solid border-black border-t xl:border-t-6">
            <h2 className="uppercase pt-4">Sponsors</h2>
            <div className="flex flex-wrap items-center justify-center w-full pt-4">
              {sponsors.map(({ title, link, imageWithColor, image }, i) => (
                <a
                  key={`sponsor_link_${i}`}
                  href={link}
                  target="_blank"
                  className="pr-10 py-2 w-1/2 md:w-1/3 lg:w-1/5 lg:pr-8 flex items-center justify-center"
                  rel="noopener noreferrer"
                >
                  <img
                    className="object-cover w-full brightness-0"
                    src={imageWithColor?.asset?.url || image?.asset?.url || ""}
                    alt={`${title} logo`}
                  />
                </a>
              ))}
            </div>
          </div>
        </>
      )}

      {partners.length > 0 && (
        <>
          <div className="w-full py-2 flex flex-col items-center border-solid border-black border-t xl:border-t-6">
            <h2 className="uppercase pt-4">Contributing partners</h2>
            <div className="flex flex-wrap items-center justify-center w-full">
              {partners.map(({ title, link, imageWithColor, image }, i) => (
                <div
                  className="pr-4 lg:pr-8 py-2 w-1/2 md:w-1/4"
                  key={`sponsor_link_${i}`}
                >
                  <a
                    href={link}
                    target="_blank"
                    className="netlife-sans font-bold"
                    rel="noopener noreferrer"
                  >
                    <img
                      className="object-cover w-full brightness-0"
                      src={
                        imageWithColor?.asset?.url || image?.asset?.url || ""
                      }
                      alt={`${title} logo`}
                    />
                  </a>
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Sponsors;
